// src/components/Arknights.jsx
import React, { useEffect, useRef } from "react";
import DameDaneParticle from "./js/canvasClass";

const Arknights = ({ src, options = {}, width = "100%", height = "100%" }) => {
  const canvasRef = useRef(null);
  const particleInstance = useRef(null);

  useEffect(() => {
    let instance;

    if (canvasRef.current) {
      console.log("开始加载粒子效果，图片路径:", src);

      // 预先检查图片是否存在
      const img = new Image();
      img.onload = () => {
        console.log("图片加载成功，开始初始化粒子效果");
        // 初始化粒子效果
        instance = new DameDaneParticle(
          canvasRef.current,
          { src, ...options },
          () => {
            console.log("粒子效果初始化完成");
          }
        );
      };
      particleInstance.current = instance;

      img.onerror = (err) => {
        console.error("图片加载失败，请检查路径是否正确:", src);
        console.error("错误详情:", err);
      };

      img.src = src;
    }

    // 清理函数
    return () => {
      console.log("执行清理函数");
      if (particleInstance.current) {
        particleInstance.current.PreDestory();
        particleInstance.current = null;
      }
    };
  }, [src, options]);

  return (
    <canvas
      ref={canvasRef}
      style={{
        width,
        height,
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 10,
        pointerEvents: "none", // 禁止鼠标事件
      }}
    />
  );
};

export default Arknights;
